import axios from "axios";

export const createSurveyTemplate = async (tokenC, detail) => {

  return await axios.post(
    `${process.env.REACT_APP_API}/surveyTemplate/create`,
    detail,
    {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};

export const List = async (tokenC, page, perPage) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/surveyTemplate/list?page=${page || 1}&perPage=${
      perPage || 10
    }`,
    {
      headers: {
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};

export const SearchList = async (tokenC, searchValue) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/surveyTemplate/survey-template-list?title=${searchValue || ''}`,
    {
      headers: {
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};


export const Update = async (id, tokenC, detail) => {
  return await axios.put(
    `${process.env.REACT_APP_API}/surveyTemplate/update/${id}`,
    detail,
    {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};

export const Delete = async (id, tokenC) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/surveyTemplate/delete/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};